export default {
  placeholder: 'Escribe tu nota...',
  insert: 'Insertar Texto',
  label: {
    link: 'Enlace',
  },
  button: {
    confirm: 'Confirmar',
  },
};
